import { useQuery } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const db = (t: string): any => (supabase as any).from(t)

function todayIso(): string {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export function useOverdueReleaseCount(tid: string) {
  return useQuery<number>({
    queryKey: ['overdue-release-count', tid],
    enabled: !!tid,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
    queryFn: async () => {
      const { data: schedules } = await db('expense_schedules')
        .select('id')
        .eq('tenant_id', tid)
        .eq('status', 'active')
      const ids = ((schedules ?? []) as { id: string }[]).map(s => s.id)
      if (ids.length === 0) return 0
      const today = todayIso()
      const { count } = await db('expense_schedule_lines')
        .select('id', { count: 'exact', head: true })
        .eq('tenant_id', tid)
        .eq('is_posted', false)
        .lte('month_date', today)
        .in('schedule_id', ids)
      return count ?? 0
    },
  })
}
